import React from 'react';
import { Card, CardContent, Typography, Button, Box, Grid } from '@mui/material';
import Snackbar from './Snackbar';


interface PricingPlanCardProps {
    title: string;
    price: string;
    features: string[];
    buttonText: string;
}

const PricingPlanCard: React.FC<PricingPlanCardProps> = ({ title, price, features, buttonText }) => {
    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        setOpen(false);
    };
    const handleClick = () => {
        setOpen(true);
    };
    return (
        <Card
            sx={{
                minWidth: 275,
                margin: 2,
                textAlign: 'center',
                background: 'linear-gradient(135deg, #536dfe 20%, #18ffff 90%)', // Gradient background
                color: 'white', // Text color for contrast
                borderRadius: '15px', // Optional styling for rounded corners
                height: '380px'
            }}
        >
            <CardContent>
                <Typography variant="h5" component="div" sx={{ fontSize: 35 }}>
                    {title}
                </Typography>
                <Grid container spacing={0} justifyContent="center">
                    <Typography variant="h4" component="div" sx={{ my: 2, color: 'white' }}>
                        {price}
                    </Typography>
                    <Typography variant="h5" component="div" sx={{ my: 4 }}>
                        /1 user・month
                    </Typography>
                </Grid>
                <Box sx={{ mb: 2 }}>
                    {features.map((feature, index) => (
                        <Typography key={index} variant="body2" sx={{ fontSize: 20 }}>
                            {feature}
                        </Typography>
                    ))}
                </Box>
                <Button variant="contained" color="primary" onClick={handleClick}>
                    {buttonText}
                </Button>
            </CardContent>
            <Snackbar
                open={open}
                closeFunc={handleClose}
                message="gallerylambda+onso@gmail.com 宛にメールをいただけますと幸いです。"
            />
        </Card>

    );
};

export default PricingPlanCard;
